
type TAnyValue = string | boolean | number | undefined | null;

export enum EPredicate {
    Exists = "exists",
    Is = "is",
    Includes = "includes",
    Less = "less",
    Greater = "greater"
};



export interface IConditionMapping {
    [EPredicate.Exists]: boolean;
    [EPredicate.Is]: TAnyValue;
    [EPredicate.Includes]: string | number;
    [EPredicate.Less]: number;
    [EPredicate.Greater]: number;
};

export type ISingleCondition = Partial<IConditionMapping>;

export interface IRuleConditions { [key: string]: ISingleCondition };

export type TConditionList = Array<{ [key: string]: ISingleCondition }>;



export enum EDefaultRuleActionType {
    Remove = "remove",
    Require = "require"
};

export enum EAdditionalActionType {
    HideEmptyFields = "hideEmptyFields"
};

export const ActionType = {
    ...EDefaultRuleActionType,
    ...EAdditionalActionType,
}

export type EKnownActionType = EDefaultRuleActionType | EAdditionalActionType;

export type TRuleActionType = EKnownActionType | string;



export interface IRuleEvent {
    type: TRuleActionType;
    params?: { [key: string]: any }
};



export interface ISchemaRule {
    key?: string;
    conditions: IRuleConditions | { not: (IRuleConditions | { or: Array<IRuleConditions> }) } | { or: Array<IRuleConditions> };
    event: IRuleEvent | Array<IRuleEvent>;
};

export default ISchemaRule;

